import React, { useState } from 'react'; 
import Popup from '../components/CusPopup';
import { Checkbox } from '@progress/kendo-react-inputs';
import eData from '../hybriddata/popupdata.json';
import { Button } from '@progress/kendo-react-buttons';

const EnterpriseDeclarePopup = (props) => {
    const {popupValue,setPopupValue} =props;
    const [isChecked, setIsChecked] = useState(false);

    const handleChkChange = (e) => {
        setIsChecked(e.value);
    }
    return(
        <Popup className="popUpBox" trigger={popupValue} setTrigger={setPopupValue}>
            <div className='fbaPSize'>
                <div className="bgBlackYellowBorder">
                    <div className="row">
                        <div className="col-10">
                            <div className="dcPgmh">{eData.entDeclare.header}</div>
                        </div>
                    </div>
                </div><br/>
                <div className="fbaPSize" style={{ textAlign: "left", display: 'flex', flexWrap: 'wrap', paddingBottom: '10px', paddingTop: '10px', fontSize: "small" }}>
                    <Checkbox defaultChecked={isChecked} label={eData.entDeclare.cbdata} onChange={handleChkChange} />
                </div>
                {eData.entDeclare.declareList.map((item, idx) => (
                    <div key={idx}>
                        <div style={{ textAlign: "left", display: 'flex', flexWrap: 'wrap', color: '#585858' }}>
                            <ol style={{ listStyle: "disc", marginBottom: "0", fontSize: "x-small" }}>
                                <li>{item.lblname}</li>
                            </ol>
                        </div>
                    </div>
                ))}
                <br/>
                <div className="row">
                    <div className="col-6" style={{ textAlign: "left" }}>
                        <Button look="outline" className="btSize1 sccbTxt2"
                            onClick={() => setPopupValue(false)}>{'Back'}</Button>
                    </div>
                    <div className="col-6" style={{ textAlign: "right" }}>
                        <Button primary={true} className="btSize1 sccbTxt2 btRht greenbt"
                            disabled={!isChecked}
                            onClick={props.onClickProceed}>{'PROCEED'}</Button>
                    </div>
                </div>
                <br/>
            </div>
        </Popup>
    )
}

export default EnterpriseDeclarePopup